// extracted by mini-css-extract-plugin
export default {"item":"SocialNetworkItem_item__g5GcI"};